/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import a from "prop-types";
import { validatePackage as b, dispatchEvent as l, useDir as k, getTabIndex as f, classNames as d } from "@progress/kendo-react-common";
import { packageMetadata as C } from "../package-metadata.mjs";
const r = t.forwardRef((e, s) => {
  b(C);
  const c = t.useRef(null), i = t.useRef(null), m = t.useCallback(
    () => {
      i.current && i.current.focus();
    },
    [i]
  );
  t.useImperativeHandle(c, () => ({
    element: i.current,
    focus: m,
    props: e
  })), t.useImperativeHandle(s, () => c.current);
  const u = t.useCallback(
    (n) => {
      e.id && l(e.onItemSelect, n, n.target, { id: e.id });
    },
    [e.onItemSelect]
  ), o = t.useCallback(
    (n) => {
      e.id && l(e.onKeyDown, n, n.target, { id: e.id });
    },
    [e.onKeyDown]
  );
  return /* @__PURE__ */ t.createElement(
    "a",
    {
      href: "#",
      "aria-current": e.ariaCurrent ? e.ariaCurrent : e.isLast,
      role: "link",
      id: e.id,
      ref: i,
      style: e.style,
      dir: k(i, e.dir),
      tabIndex: f(e.tabIndex, e.disabled),
      className: d(
        {
          "k-breadcrumb-root-link": e.isFirst,
          "k-breadcrumb-link": !e.isFirst,
          "k-breadcrumb-icontext-link": (e.icon !== void 0 || e.iconClass !== void 0) && e.text,
          "k-breadcrumb-icon-link": (e.icon !== void 0 || e.iconClass !== void 0) && !e.text,
          "k-disabled": e.disabled
        }
      ),
      onClick: (n) => {
        n.preventDefault(), u(n);
      },
      onKeyDown: o
    },
    e.iconClass ? /* @__PURE__ */ t.createElement("span", { className: d("k-icon", e.iconClass) }) : e.icon ? e.icon : "",
    e.text && /* @__PURE__ */ t.createElement("span", { className: "k-breadcrumb-item-text" }, e.text)
  );
}), x = {
  id: a.string,
  className: a.string,
  tabIndex: a.number,
  style: a.object,
  dir: a.string,
  disabled: a.bool,
  text: a.string,
  icon: a.node,
  iconClass: a.string,
  onClick: a.func,
  ariaCurrent: a.bool
};
r.displayName = "KendoReactBreadcrumbLink";
r.propTypes = x;
export {
  r as BreadcrumbLink
};
